import React from "react";

interface ConnectionButtonProps {
  isConnected: boolean;
  isConnecting: boolean;
  onConnect: () => void;
  onDisconnect: () => void;
}

export const ConnectionButton: React.FC<ConnectionButtonProps> = ({
  isConnected,
  isConnecting,
  onConnect,
  onDisconnect,
}) => {
  return (
    <>
      <button
        onClick={onConnect}
        disabled={isConnected || isConnecting}
        style={{
          padding: "0.75rem 1.5rem",
          fontSize: "1rem",
          backgroundColor: isConnected
            ? "#ccc"
            : isConnecting
              ? "#ffc107"
              : "#28a745",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: isConnected || isConnecting ? "not-allowed" : "pointer",
        }}
      >
        {isConnecting
          ? "⏳ Connecting..."
          : isConnected
            ? "🟢 Connected"
            : "Connect"}
      </button>
      {isConnecting && (
        <span style={{ color: "#666", fontSize: "0.9rem" }}>
          Connection in progress... Check messages below for details
        </span>
      )}
      <button
        onClick={onDisconnect}
        disabled={!isConnected}
        style={{
          padding: "0.75rem 1.5rem",
          fontSize: "1rem",
          backgroundColor: !isConnected ? "#ccc" : "#dc3545",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: !isConnected ? "not-allowed" : "pointer",
        }}
      >
        Disconnect
      </button>
    </>
  );
};

interface ClearButtonProps {
  onClick: () => void;
}

export const ClearButton: React.FC<ClearButtonProps> = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      style={{
        padding: "0.5rem 1rem",
        fontSize: "0.9rem",
        backgroundColor: "#6c757d",
        color: "white",
        border: "none",
        borderRadius: "4px",
        cursor: "pointer",
      }}
    >
      Clear
    </button>
  );
};

interface SubscriptionButtonProps {
  channel: string;
  isSubscribed: boolean;
  isConnected: boolean;
  disabled?: boolean;
  subscribeLabel: string;
  unsubscribeLabel: string;
  onSubscribe: () => void;
  onUnsubscribe: () => void;
  variant?: "public" | "private";
}

export const SubscriptionButton: React.FC<SubscriptionButtonProps> = ({
  channel,
  isSubscribed,
  isConnected,
  disabled = false,
  subscribeLabel,
  unsubscribeLabel,
  onSubscribe,
  onUnsubscribe,
  variant = "public",
}) => {
  const isDisabled = !isConnected || disabled;
  const backgroundColor = isSubscribed
    ? "#dc3545"
    : variant === "private"
      ? "#28a745"
      : "#007bff";

  return (
    <button
      onClick={isSubscribed ? onUnsubscribe : onSubscribe}
      disabled={isDisabled}
      style={{
        padding: "0.5rem 1rem",
        fontSize: "0.9rem",
        backgroundColor,
        color: "white",
        border: "none",
        borderRadius: "4px",
        cursor: isDisabled ? "not-allowed" : "pointer",
      }}
    >
      {isSubscribed ? unsubscribeLabel : subscribeLabel}
    </button>
  );
};

